import React, { useState } from 'react';
import useShots from '../../../../hooks/use-shots';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../../../stores/types/types';
import { useDragDetectFeed } from '../../../../hooks/content/use-drag-detect-feed';
import styled from 'styled-components';
import DebugContentErrors from './debug-content-errors';
import colors from '../../../../utils/colors';

const TabButton = styled.button<{ active: boolean }>`
	padding: 8px 16px;
	background-color: ${ props => props.active ? colors.blGrayscale700 : colors.blGrayscale800 };
	border: 1px solid ${ props => props.active ? colors.blGrayscale600 : colors.blGrayscale700 };
	color: ${ props => props.active ? colors.blGrayscale100 : colors.blGrayscale300 };
	border-radius: 6px;
	cursor: pointer;
	font-size: 12px;
	font-weight: ${ props => props.active ? '600' : '400' };
	transition: all 0.2s ease;

	&:hover {
		background-color: ${ colors.blGrayscale700 };
		color: ${ colors.blGrayscale100 };
	}
`;

function TitleLinkRow(props: { graphicId: number }) {
	const { feedPresenter } = useDragDetectFeed(props.graphicId);
	const invite = useSelector((s: GreenroomState) => s.InvitationsReducer.invitations)
		.find((i) => i.profile.gr_user === feedPresenter);
	return <div>
		<span>{props.graphicId}: </span>
		<span>{feedPresenter ?? 'none'}</span>
		{invite ? <span>, {invite.profile.email}</span> : null}
	</div>
}

export default function DebugTitles() {
	const { defaultThemes } = useSelector((s: GreenroomState) => s.ThemesReducer)
	const { currentShot: { shot_data: { shotGraphics } } } = useShots();
	const [activeTab, setActiveTab] = useState<'info' | 'errors'>('info');

	return (<div>
		<div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
			<TabButton active={activeTab === 'info'} onClick={() => setActiveTab('info')}>
				Title Info
			</TabButton>
			<TabButton active={activeTab === 'errors'} onClick={() => setActiveTab('errors')}>
				Content Errors
			</TabButton>
		</div>

		{activeTab === 'info' && (
			<div>
				<div>graphic id: user id, email</div>
				{shotGraphics?.map((id) => <TitleLinkRow graphicId={id} key={id} />)}

				<h4 className='bl-font-header' style={{ marginBottom: '4px', marginTop: '16px' }}>Themes</h4>
				{defaultThemes.map((t) => (
					<div key={t.name}>
						<h6 className='bl-font-header' style={{ margin: '4px 0' }}>{t.name}</h6>
						<div className='flex'>
							{t.colors.map((c) => <div key={c} style={{
								height: '100px',
								width: '100px',
								backgroundColor: c
							}}>
								<div style={{ color: 'black' }}>{c}</div>
								<div style={{ color: 'white' }}>{c}</div>
							</div>)}
						</div>
					</div>
				))}
			</div>
		)}

		{activeTab === 'errors' && <DebugContentErrors />}
	</div>);
}